import { inputStyles } from "../styles/styles";

import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { updateCustomerInfo } from "../store/customerInformation/actions";
import {
  EasyCepCustomerStatuStates,
  getNextStep,
  getNextStep4Easycep,
  getNumberFormat,
  getProductTypeString,
  getFirmRedirectUrlFromShopUrl,
  linksStates,
} from "../utils/enums";
import BaseWindow from "./public/BaseWindow";
import NotFoundPage from "./public/NotFoundPage";
import {
  PhoneNumberMask,
  PhoneNumberMask2Digit,
  TCKNMask,
  VKNMask,
} from "./public/TextMask";

import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  getCustAutoCompleteInfo,
  sendApplicantCompany,
} from "../store/customerInformation/thunkActions";
import { generateOtpEasycep } from "../store/global/thunkActions";
import { addProcessContext } from "../store/processContext/actions";
import {
  updateUnsuccessMsg,
  updateUnsuccessRedirectUrl,
} from "../store/unsuccess/actions";
import { getErrorMessage, stateHandler } from "../utils/enums";
import BaseTextField from "./public/BaseTextField";
import OtpModal from "./public/OtpModal";

import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { useDispatch } from "react-redux";
import { updateAlert } from "../store/alert/actions";
import { getProductInfo } from "../store/limitAndPaymentInformation/thunkActions";

function EasycepStep1(props) {
  const dispatch = useDispatch();
  const classes = inputStyles();
  let history = useHistory();
  let { uuid } = useParams();
  const pageName = "easycepStep1";
  const linkRef = useRef();

  const inputDataDefaultState = {
    appType: {
      value: "1",
      error: false,
      helperText: "",
    },
    tckn: {
      value: "",
      error: false,
      helperText: "",
    },
    taxNo: {
      value: "",
      error: false,
      helperText: "",
    },
    phone: {
      value: "",
      error: false,
      helperText: "",
    },
    email: {
      value: "",
      error: false,
      helperText: "",
    },
    kisiselVerilerCheckBox: {
      value: false,
      error: false,
      helperText: "",
    },
  };
  const [inputData, setInputData] = useState(inputDataDefaultState);
  const [kvkkEnabled, setKvkkEnabled] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [otpTryCount, setOtpTryCount] = useState(0);

  const [easycepCase, setEasycepCase] = useState();
  const [isPhoneNumberEditable, setPhoneNumberEditable] = useState(false);
  const [isPhoneNumberEditButtonVisible, setPhoneNumberEditButtonVisible] =
    useState(true);

  useEffect(() => {
    if (props.customerInformations) {
      inputDataChange("tckn", props.customerInformations.tckn || "");
      inputDataChange("phone", props.customerInformations.phoneNumber || "");
      inputDataChange("email", props.customerInformations.email || "");
      inputDataChange("appType", props.customerInformations.appType || "1");
      if (props.customerInformations.appType === "2") {
        inputDataChange("taxNo", props.customerInformations.taxNo || "");
      }
    }

    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        devamClick();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const inputDataChange = (propName, value, type) => {
    let setVal = value;
    switch (type) {
      case "date":
        console.log(value);
        setVal = value && value !== "" ? new Date(value) : null;
        break;
      default:
        setVal = value;
        break;
    }
    setInputData((prevState) => {
      return {
        ...prevState,
        [propName]: {
          value: setVal,
          error: prevState[propName].error,
          helperText: prevState[propName].helperText,
        },
      };
    });
  };

  const setInputDataErrorChange = (
    prevState,
    propName,
    equalVal,
    helperText,
    type,
  ) => {
    let compairingVal = "";
    switch (type) {
      case "length":
        compairingVal = prevState[propName].value.length;
        break;
      case "indexOf":
        compairingVal = prevState[propName].value.indexOf("@") !== -1;
        break;
      case "null":
        compairingVal = prevState[propName].value === null;
        break;
      default:
        compairingVal = prevState[propName].value;
        break;
    }
    if (compairingVal !== equalVal) {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: true,
          helperText,
        },
      };
    } else {
      if (type !== "null") {
        return {
          ...prevState,
          [propName]: {
            value: prevState[propName].value,
            error: false,
            helperText: "",
          },
        };
      } else {
        return prevState;
      }
    }
  };

  const validationCheck = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );

      if (inputData.appType === "2") {
        prevState = setInputDataErrorChange(
          prevState,
          "taxNo",
          10,
          getErrorMessage("MS0003"),
          "length",
        );
      }

      prevState = setInputDataErrorChange(
        prevState,
        "phone",
        isPhoneNumberEditable ? 10 : 2,
        getErrorMessage("MS0004"),
        "length",
      );
      /*
      prevState = setInputDataErrorChange(
        prevState,
        "email",
        true,
        "Geçerli Bir Email giriniz",
        "indexOf"
      );*/
      prevState = setInputDataErrorChange(
        prevState,
        "kisiselVerilerCheckBox",
        true,
        getErrorMessage("MS0006"),
        "checked",
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const validationCheck4PhoneVerify = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );
      if (isPhoneNumberEditable) {
        prevState = setInputDataErrorChange(
          prevState,
          "phone",
          10,
          getErrorMessage("MS0004"),
          "length",
        );
      }

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const validationCheck4MailVerify = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "email",
        true,
        getErrorMessage("MS0025"),
        "indexOf",
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const verifyWithOtp = (otpType) => {
    let body = {
      nationalIdentityNo: inputData.tckn.value,
      taxNumber: inputData.taxNo.value,
      validateMobileNumber: "1",
      otpType,
      externalId: uuid,
      companyCode: props.processContext.companyCode,
      agencyCode: props.processContext.agencyCode,
      productType: props.processContext.productType,
    };

    switch (otpType) {
      case "SMS":
        if (!validationCheck4PhoneVerify()) {
          return;
        }
        body = {
          ...body,
          mobileNumber: isPhoneNumberEditable ? inputData.phone.value : "",
        };
        break;
      case "MAIL":
        if (!validationCheck4MailVerify()) {
          return;
        }
        body = {
          ...body,
          mail: inputData.email.value,
        };
        break;
      default:
        return;
    }

    //setOtpModalOpen(true);

    props.actions.generateOtpEasycep(body).then((res) => {
      if (res === true) {
        setOtpType(otpType);
        setOtpModalOpen(true);
        setOtpTryCount((prevState) => prevState++);
      }
    });
  };

  const temizleClick = () => {
    setInputData(inputDataDefaultState);
    setEasycepCase(null);
    setPhoneNumberEditable(false);
    props.actions.updateCustomerInfo({
      phoneValidationCheck: false,
      mailValidationCheck: false,
    });
  };

  const devamClick = (e) => {
    if (!easycepCase) {
      props.actions.updateAlert({
        severity: "error",
        text: "Müşteri doğrulaması yapılmadan devam edemezsiniz.",
        open: true,
      });
      return;
    }
    if (validationCheck()) {
      if (!props.customerInformations.phoneValidationCheck) {
        props.actions.updateAlert({
          severity: "error",
          text: "Devam etmeden önce cep telefonunuzu doğrulayınız",
          open: true,
        });
      } else {
        if (
          easycepCase ===
          EasyCepCustomerStatuStates.CUSTOMER_WITHOUT_APPROVED_AMOUNT
        ) {
          props.actions.updateUnsuccessMsg(getErrorMessage("MS0028"));
          const nextStepName = "unsuccess";
          props.actions.addProcessContext({ stepName: nextStepName });
          history.push("/" + uuid + "/" + nextStepName);

          return;
        }
        callService();
      }
      //history.push(getNextStep(pageName));
    } else {
      props.actions.updateAlert({
        severity: "error",
        text: "Validasyon Hatası.",
        open: true,
      });
    }
  };

  const callService = () => {
    const appType = inputData.appType.value;
    const taxNo = appType === "2" ? inputData.taxNo.value : "";
    const tckn = inputData.tckn.value;
    const phone = inputData.phone.value;
    const email = inputData.email.value;

    const requestBody = {
      companyCode: props.processContext.companyCode,
      agencyCode: props.processContext.agencyCode,
      nationalIdentityNo: tckn,
      mobilePhone: phone?.length === 10 ? phone : "",
      referenceNo: props.processContext.referenceNo,
      email: email,
      emailValid: props.customerInformations?.mailValidationCheck ? "1" : "0",
      externalId: uuid,
      otpOID: props.global.otpInfo?.otpOID,
      appType,
      taxNo,
      caseId: easycepCase,
      productType: props.processContext.productType,
    };

    props.actions.updateCustomerInfo({
      tckn: tckn,
      phoneNumber: phone,
      email: inputData.email.value,
      appType,
      taxNo,
    });

    props.actions.updateUnsuccessRedirectUrl(null);

    props.actions.sendApplicantCompany(requestBody).then((res) => {
      const result = stateHandler(res.appState);

      if (result === undefined) {
        props.actions.updateUnsuccessRedirectUrl(null);
        return;
      }

      const firmRedirectUrl = getFirmRedirectUrlFromShopUrl(res.shopUrl);

      const shouldShowFirmButton =
        result?.result !== "0" &&
        firmRedirectUrl &&
        (res.appState === linksStates.REFUSE ||
          res.appState === linksStates.LIMIT_NOT_ENOUGH);

      props.actions.updateUnsuccessRedirectUrl(
        shouldShowFirmButton ? firmRedirectUrl : null,
      );

      if (result?.result !== "0") {
        /*  Limit yetersiz mesajında limit bilgisini de gösterebilmek için eklendi!! */
        if (
          res.appState === linksStates.LIMIT_NOT_ENOUGH &&
          res.limitAmount !== undefined &&
          res.limitAmount !== null
        ) {
          props.actions.updateUnsuccessMsg(
            "Onaylanan limitiniz  " +
              getNumberFormat(res.limitAmount) +
              " TL'dir. Bu tutar sepetiniz için yeterli değildir. " +
              "Sepet tutarınızı güncelleyerek yeniden deneyebilirsiniz.",
          );
        } else if (res.appState === linksStates.LIMIT_NOT_ENOUGH) {
          props.actions.updateUnsuccessMsg(getErrorMessage("MS0001"));
        } else if (res.appState === linksStates.HOLD) {
          props.actions.updateUnsuccessMsg(getErrorMessage("MS0027"));
        } else {
          props.actions.updateUnsuccessMsg(
            result.errorCode ? getErrorMessage(result.errorCode) : result.msg,
          );
        }
      }

      const nextStepName = getNextStep4Easycep(pageName, result.result);
      props.actions.addProcessContext({ stepName: nextStepName });
      history.push("/" + uuid + "/" + nextStepName);
    });
  };

  const getCustomerInfos = (value, valueType, appType) => {
    if (appType === "1") {
      if (value.length !== 11) {
        props.actions.updateAlert({
          severity: "error",
          text: "Geçersiz bir tckn girdiniz.",
          open: true,
        });
        return;
      }
      props.actions
        .getCustAutoCompleteInfo({
          nationalIdentityNo: value,
          externalId: uuid,
          companyCode: props.processContext.companyCode,
          agencyCode: props.processContext.agencyCode,
          productType: props.processContext.productType,
        })
        .then((res) => {
          if (res.data) {
            inputDataChange("phone", res.data?.mobilePhone?.slice(-2));
            setEasycepCase(res.data.caseId);
            if (res.data?.mobilePhone === "") {
              setPhoneNumberEditButtonVisible(false);
            } else {
              setPhoneNumberEditButtonVisible(true);
            }
            if (
              res.data.caseId ===
                EasyCepCustomerStatuStates.POTENTIAL_WITH_APPROVED_AMOUNT ||
              res.data?.mobilePhone === ""
            ) {
              setPhoneNumberEditable(true);
            } else {
              setPhoneNumberEditable(false);
            }
          } else if (res.nextStatus) {
            props.actions.updateUnsuccessMsg(res.msg);
            const nextStepName = getNextStep(pageName, res.result);
            props.actions.addProcessContext({ stepName: nextStepName });
            history.push("/" + uuid + "/" + nextStepName);
          }
        });
    } else {
      if (valueType === "tckn") {
        if (value.length !== 11) {
          if (value !== "") {
            props.actions.updateAlert({
              severity: "error",
              text: "Geçersiz bir tckn girdiniz.",
              open: true,
            });
          }
          return;
        } else if (inputData.taxNo?.value?.length !== 10) {
          return;
        }
      }
      if (valueType === "vkn") {
        if (value.length !== 10) {
          if (value !== "") {
            props.actions.updateAlert({
              severity: "error",
              text: "Geçersiz bir vkn girdiniz.",
              open: true,
            });
          }
          return;
        } else if (inputData.tckn?.value?.length !== 11) {
          return;
        }
      }

      props.actions
        .getCustAutoCompleteInfo({
          taxNumber: value.length === 10 ? value : inputData.taxNo?.value,
          nationalIdentityNo:
            value.length === 11 ? value : inputData.tckn.value,
          externalId: uuid,
          companyCode: props.processContext.companyCode,
          agencyCode: props.processContext.agencyCode,
          productType: props.processContext.productType,
        })
        .then((res) => {
          if (res.data) {
            inputDataChange("phone", res.data?.mobilePhone?.slice(-2));
            setEasycepCase(res.data.caseId);
            if (res.data?.mobilePhone === "") {
              setPhoneNumberEditButtonVisible(false);
            } else {
              setPhoneNumberEditButtonVisible(true);
            }
            if (
              res.data.caseId ===
                EasyCepCustomerStatuStates.POTENTIAL_WITH_APPROVED_AMOUNT ||
              res.data?.mobilePhone === ""
            ) {
              setPhoneNumberEditable(true);
            } else {
              setPhoneNumberEditable(false);
            }
          } else if (res.nextStatus) {
            props.actions.updateUnsuccessMsg(res.msg);
            const nextStepName = getNextStep(pageName, res.result);
            props.actions.addProcessContext({ stepName: nextStepName });
            history.push("/" + uuid + "/" + nextStepName);
          }
        });
    }
  };

  return props.processContext.stepName !== pageName ? (
    <NotFoundPage />
  ) : (
    <BaseWindow isBasket={true}>
      <OtpModal
        open={otpModalOpen}
        setOpen={setOtpModalOpen}
        setOtpVerified={setOtpVerified}
        otpType={otpType}
        tckn={inputData.tckn.value}
        taxNumber={inputData.taxNo.value}
        phoneNumber={inputData.phone.value}
        uuid={uuid}
      />
      <Grid item xs={12}>
        <p className={classes.label}>
          Ödemenizi Fibabanka{" "}
          {getProductTypeString(props.processContext?.productType)} Kredisi ile
          gerçekleştirmek için aşağıdaki alanları doldurunuz.
        </p>
      </Grid>
      <Grid item xs={12}>
        <RadioGroup
          row
          value={inputData.appType.value}
          onChange={(ev) => {
            temizleClick();
            inputDataChange("appType", ev.target.value);
          }}
        >
          <FormControlLabel
            value="1"
            control={<Radio color="primary" />}
            label="Şahıs İşletmesi/ Esnaf "
            classes={{
              label: classes.label,
            }}
          />
          <FormControlLabel
            value="2"
            control={<Radio color="primary" />}
            label="Tüzel Firma (Limited)"
            classes={{
              label: classes.label,
            }}
          />
        </RadioGroup>
      </Grid>
      {inputData.appType.value === "2" && (
        <Grid item xs={12}>
          <p className={classes.p}>{"Vergi Kimlik Numarası"} </p>
          <BaseTextField
            error={inputData.taxNo.error}
            helperText={inputData.taxNo.helperText}
            value={inputData.taxNo.value}
            onChange={(ev) => inputDataChange("taxNo", ev.target.value)}
            disabled={props.customerInformations.phoneValidationCheck}
            onBlur={(ev) => {
              getCustomerInfos(
                ev.target?.value?.replaceAll("_", ""),
                "vkn",
                "2",
              );
            }}
            InputProps={{
              inputComponent: VKNMask,
            }}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <p className={classes.p}>
          {inputData.appType.value === "2"
            ? "Ortak T.C. Kimlik Numarası"
            : "T.C. Kimlik Numarası"}{" "}
        </p>
        <BaseTextField
          error={inputData.tckn.error}
          helperText={inputData.tckn.helperText}
          value={inputData.tckn.value}
          onChange={(ev) => inputDataChange("tckn", ev.target.value)}
          onBlur={(ev) => {
            getCustomerInfos(
              ev.target?.value?.replaceAll("_", ""),
              "tckn",
              inputData.appType.value,
            );
          }}
          disabled={props.customerInformations.phoneValidationCheck}
          InputProps={{
            inputComponent: TCKNMask,
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <p className={classes.p}>Cep Telefonu</p>

        <BaseTextField
          error={inputData.phone.error}
          helperText={inputData.phone.helperText}
          value={inputData.phone.value}
          onChange={(ev) => inputDataChange("phone", ev.target.value)}
          disabled={
            !isPhoneNumberEditable ||
            props.customerInformations.phoneValidationCheck
          }
          InputProps={{
            inputComponent:
              easycepCase ===
                EasyCepCustomerStatuStates.POTENTIAL_WITH_APPROVED_AMOUNT ||
              isPhoneNumberEditable
                ? PhoneNumberMask
                : PhoneNumberMask2Digit,
            endAdornment: (
              <InputAdornment position="end">
                {props.customerInformations.phoneValidationCheck ? (
                  <IconButton>
                    <CheckCircleOutlineIcon style={{ color: "#5cb85c" }} />
                  </IconButton>
                ) : (
                  <>
                    {easycepCase &&
                      easycepCase !==
                        EasyCepCustomerStatuStates.POTENTIAL_WITH_APPROVED_AMOUNT &&
                      isPhoneNumberEditButtonVisible && (
                        <Button
                          variant="contained"
                          color={"primary"}
                          size={"small"}
                          onClick={() => {
                            setPhoneNumberEditable((prevState) => {
                              if (prevState) {
                                getCustomerInfos(
                                  inputData.tckn?.value,
                                  "tckn",
                                  inputData.appType.value,
                                );
                                return false;
                              } else {
                                inputDataChange("phone", "");
                                return true;
                              }
                            });
                          }}
                          title={"Edit"}
                          style={{ textTransform: "none", marginRight: 2 }}
                        >
                          Düzenle
                        </Button>
                      )}

                    <Button
                      variant="contained"
                      color={"primary"}
                      size={"small"}
                      onClick={() => verifyWithOtp("SMS")}
                      disabled={!easycepCase}
                      title={"Doğrula"}
                      style={{ textTransform: "none" }}
                    >
                      Doğrula
                    </Button>
                  </>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      {/*<Grid item xs={12}>
        <p className={classes.p}>E-mail</p>
        <BaseTextField
          error={inputData.email.error}
          helperText={inputData.email.helperText}
          value={inputData.email.value}
          disabled={!custVerified}
          type="email"
          onChange={(ev) => inputDataChange("email", ev.target.value)}
          InputProps={
            {
              endAdornment: (
              <InputAdornment position="end">
                {props.customerInformations.mailValidationCheck ? (
                  <IconButton>
                    <CheckCircleOutlineIcon style={{ color: "#5cb85c" }} />
                  </IconButton>
                ) : (
                  <Button
                    variant="contained"
                    color={"primary"}
                    size={"small"}
                    onClick={() => verifyWithOtp("MAIL")}
                    title={"Doğrula"}
                    style={{ textTransform: "none" }}
                  >
                    Doğrula
                  </Button>
                )}
              </InputAdornment>
            ),
            }
          }
        />
      </Grid>*/}

      <div style={{ display: "flex", marginTop: 15 }}>
        <InfoIcon
          fontSize="small"
          color="disabled"
          style={{ marginRight: 5 }}
        />
        <div className={classes.informationLabel}>
          T.C. kimlik numaranız, cep telefonu numaranız ve doğum tarihiniz
          Fibabanka {getProductTypeString(props.processContext?.productType)}{" "}
          Kredisi başvurunuzun ön değerlendirmesinin yapılması ve bilgilerinizin
          doğrulanması amacıyla istenmektedir.{" "}
          <u>
            <b>
              Cep telefonunuza ya da Fibabanka mobil uygulamanıza doğrulama kodu
              gönderilecektir.
            </b>
          </u>
        </div>
      </div>
      <Grid item xs={12}>
        <FormControl
          required
          error={inputData.kisiselVerilerCheckBox.error}
          component="fieldset"
          className={classes.formControl}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={inputData.kisiselVerilerCheckBox.value}
                onChange={(ev) => {
                  if (!kvkkEnabled) {
                    linkRef.current.click();
                    /*props.actions.updateAlert({
                      severity: "error",
                      text: "Öncelikle 'Kişisel Verilerin Korunması ve İşlenmesi Hakkında Bilgilendirme Metni'ni okudum' linkine tıklayınız.",
                      open: true,
                    });*/
                  } else {
                    inputDataChange(
                      "kisiselVerilerCheckBox",
                      ev.target.checked,
                    );
                  }
                }}
                color={"primary"}
              />
            }
            label={
              <p className={classes.p}>
                <Link
                  href="https://fibabanka.com.tr/pdf/kvkk.pdf"
                  target="_blank"
                  ref={linkRef}
                  rel="noopener noreferrer"
                  onClick={() => {
                    setKvkkEnabled(true);
                    inputDataChange("kisiselVerilerCheckBox", true);
                  }}
                >
                  Kişisel Verilerin Korunması ve İşlenmesi Hakkında
                  Bilgilendirme Metni'ni okudum.
                </Link>
              </p>
            }
          />
          <FormHelperText>
            {inputData.kisiselVerilerCheckBox.helperText}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid container item style={{ marginTop: 30 }}>
        <Button
          variant="contained"
          color="default"
          size="small"
          className={classes.button}
          onClick={temizleClick}
        >
          Temizle
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={devamClick}
        >
          Devam
        </Button>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    customerInformations: state.customerInformations,
    processContext: state.processContext,
    alert: state.alert,
    global: state.global,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      updateCustomerInfo: bindActionCreators(updateCustomerInfo, dispatch),
      sendApplicantCompany: bindActionCreators(sendApplicantCompany, dispatch),
      updateUnsuccessMsg: bindActionCreators(updateUnsuccessMsg, dispatch),
      updateUnsuccessRedirectUrl: bindActionCreators(
        updateUnsuccessRedirectUrl,
        dispatch,
      ),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      generateOtpEasycep: bindActionCreators(generateOtpEasycep, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      getProductInfo: bindActionCreators(getProductInfo, dispatch),
      getCustAutoCompleteInfo: bindActionCreators(
        getCustAutoCompleteInfo,
        dispatch,
      ),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EasycepStep1);
